
import React, { Component } from 'react';
import { Form, Button, Input, Icon, message, Select, Modal } from 'antd';
import Qs from 'qs';
import http from 'libs/http';
import logoPic from 'assets/36kr_blue.png';
import './index.less';
// 人机校验
import { dataInit, importGuide, createCaptchaInstance, startCaptcha } from './verification';
import { api } from 'libs/config'
import { withContext } from 'libs/context';

const FormItem = Form.Item;
const Option = Select.Option;

const IGNORE_ALIYUN_DATA = '29d8f7acbfb8dcd0cc8c5d7c9dc58847'; // 忽略阿里校验时给服务端传的固定码

/*
  登录逻辑：
    1.密码登录 -> 验证通过，判断是否开启双因子验证：若未开启，直接登录成功；若开启，则校验验证码
    2.手机验证码登录 -> 验证通过，直接登录成功
*/

class Login extends Component {
  constructor() {
    super();
    this.state = {
      logining: false,
      redirect: false,
      marginBottom: '0', // 当无痕验证出现手动验证时的marginBottom
      // 双因子相关
      showPhoneVerify: false,
      verifyLogining: false, // 正在验证登录
      sendingCodeStatus: '', // 验证码发送状态：doing done fail
      verifyTime: 0, // 验证码倒计时
      verifyMobileNo: '', // 接收验证码的手机号(用于展示)
      verifyMobileNoCallback: '', // 用这个去发验证码
      verifyCodeCallback: '', // 这个是验证码发送成功后的认证
      loginWithPwd: true,
      visible: true
    };
  }

  componentDidMount () {
    setTimeout(async()=>{
      let logInDom = document.getElementById('login-dom')
      let domAttr = ''
      if (logInDom.currentStyle) {
        domAttr = logInDom.currentStyle[ 'display' ];
      } else  if (window.getComputedStyle) {
        domAttr = window.getComputedStyle(logInDom ,  null )[ 'display' ]
      }
      
      // 1. 设置全局配置
      dataInit();
      
      // 2. 加载 SDK 并创建 DOM 元素（实例在点击时创建）
      importGuide();

      
      await createCaptchaInstance();


      if (domAttr === 'block') {
        message.error('登录已失效，请重新登录')
        // this.getCountryList();
      }
    }, 1000)
  }

  getCountryList () {
    http.json('/tool/countryCode', { param: {} }, { baseURL: api.sso })
      .then(res => {
        this.setState({
          countryCodeList: res.countryCodeList || [],
          countryCodeName: res.countryCodeName,
          countryCode: res.countryCode
        })
      })
  }

  // 执行预登录
  handleSubmitPwd = (e) => {
    e.preventDefault();

    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        try {
          // 1. 密码加密
          const JSEncrypt = require('jsencrypt');
          const encrypt = new JSEncrypt.JSEncrypt();
          encrypt.setPublicKey('MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCeiLxP4ZavN8qhI+x+whAiFpGWpY9y1AHSQC86qEMBVnmqC8vdZAfxxuQWeQaeMWG07lXhXegTjZ5wn9pHnjg15wbjRGSTfwuZxSFW6sS3GYlrg40ckqAagzIjkE+5OLPsdjVYQyhLfKxj/79oOfjl/lV3rQnk/SSczHW0PEyUbQIDAQAB');
          const encryptoTxt = encrypt.encrypt(values.passWord)
          values.passWord = encryptoTxt;
          // 2. 启动人机验证（实例已在页面加载时创建好）
          // values.data = await startCaptcha(); // 暂时关闭人机校验
          values.data = IGNORE_ALIYUN_DATA;
        } catch (error) {
          console.error('[Login] 人机验证失败', error);
          message.error('人机验证失败，请重试');
          return;
        }
        this.setState({ logining: true });
        http.json('/sys/user/preLogin', values, { baseURL: api.sso })
          .then(res => {
            if (res.bizCode ==='T001') {
              // 预登录成功
              this.setState({ logining: false });

              if (res.hasNeedVerify) {
                //我的天，你还需要手机号验证～T_T～
                this.setState({
                  showPhoneVerify: true,
                  verifyMobileNo: res.verifyMobileNo,
                  verifyMobileNoCallback: res.verifyMobileNoCallback,
                }, () => {
                  this.sendPhoneVerifyCode();
                });
              } else {
                this.successComFun(res)
              }
            } else {
              message.info('没有返回人机验证结果(bizCode)!');
              this.setState({ logining: false });
            }
          })
          .catch(() => this.setState({ logining: false }));
      }
    });
  }

  successComFun = (res) => {
    document.cookie = `userName=${encodeURI(res.userInfo.username)};domain=36kr.com`;
    message.success('登录成功');
    let logInDom = document.getElementById('login-dom')
    logInDom.style.display = 'none'
    this.setState({ visible: false })
    if (!document.getElementById('is-refresh')) window.history.go(0)
    http.json('/sys/index/choiceInit').then((res)=>{
      if (res.siteList.length === 1) {
        http.json('/sys/index/choice', {siteId: res.siteList[0].id})
      } else {
        const fr = encodeURIComponent(window.location.href);
        window.location.href = `/chosite?fr=${fr}`;
      }
    })
  }

  handleSubmitSms = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, { phoneVerifyCodeSms, phoneNo }) => {
      if (err) return;
      this.setState({ verifyLogining: true });
      http.json('/sys/user/login/bySms', {
        verifyCodeCallback: this.state.verifyCodeCallback,
        verifyCode: phoneVerifyCodeSms,
        countryCode: this.state.countryCode,
        mobileNo: phoneNo
      }, { baseURL: api.sso }).then(res => {
        this.setState({ logining: false });
        this.successComFun(res)
      }).catch(() => {
        this.setState({ verifyLogining: false });
      });
    });
  }

  // 发送手机验证码-双因子验证
  sendPhoneVerifyCode = () => {
    this.setState({ sendingCodeStatus: 'doing', verifyTime: 60 });

    http.json('/sys/user/verifycode', {
      verifyMobileNoCallback: this.state.verifyMobileNoCallback
    }, { baseURL: api.sso }).then(res => {
      this.setState({ sendingCodeStatus: 'done', verifyCodeCallback: res.verifyCodeCallback });
    }).catch(() => {
      this.setState({ sendingCodeStatus: 'fail', verifyTime: 60 });
    });
    // 获取验证码失败情况下，60s后重新获取
    clearInterval(this.verifyTimer);
    this.verifyTimer = setInterval(() => {
      const time = this.state.verifyTime - 1;
      this.setState({ verifyTime: time });
      if (time === 0) {
        clearInterval(this.verifyTimer);
        this.verifyTimer = null;
      }
    }, 1000);
  }

  // 发送手机验证码-手机验证码登录
  sendPhoneVerifyCodeSms = () => {
    const mobileNo = this.props.form.getFieldValue('phoneNo');

    this.setState({ sendingCodeStatus: 'doing' });
    http.json('/tool/sendSms', {
      // verifyMobileNoCallback: this.state.verifyMobileNoCallback
      countryCode: this.state.countryCode,
      mobileNo: mobileNo,
    }, { baseURL: api.sso }).then(res => {
      this.setState({ sendingCodeStatus: 'done', verifyCodeCallback: res.verifyCodeCallback, verifyTime: 60 });
    }).catch(() => {
      this.setState({ sendingCodeStatus: 'fail' });
    });
    // 获取验证码失败情况下，60s后重新获取
    clearInterval(this.verifyTimer);
    this.verifyTimer = setInterval(() => {
      const time = this.state.verifyTime - 1;
      this.setState({ verifyTime: time });
      if (time === 0) {
        clearInterval(this.verifyTimer);
        this.verifyTimer = null;
      }
    }, 1000);
  }

  // 开始验证登录
  startPhoneVerify = () => {
    this.props.form.validateFieldsAndScroll(['phoneVerifyCode'], (err, { phoneVerifyCode }) => {
      if (err) return;
      this.setState({ verifyLogining: true });
      http.json('/sys/user/loginByVerifyCode', {
        verifyMobileNoCallback: this.state.verifyMobileNoCallback,
        verifyCodeCallback: this.state.verifyCodeCallback,
        verifyCode: phoneVerifyCode
      }, { baseURL: api.sso }).then(res => {
        this.successComFun(res)
      }).catch(() => {
        this.setState({ verifyLogining: false });
      });
    });
  }

  handleCancel = () => {
    let logInDom = document.getElementById('login-dom')
    logInDom.style.display = 'none'
    this.setState({ visible: false })
  }

  toChosite = () => {
    const fr = encodeURIComponent(window.location.href);
    window.location.href = `/chosite?fr=${fr}`;
  }


  render () {
    const { visible } = this.props
    const { getFieldDecorator } = this.props.form;
    const {
      logining, marginBottom, showPhoneVerify, sendingCodeStatus, verifyLogining, verifyTime, verifyMobileNo, loginWithPwd
    } = this.state;

    // 双因子验证
    if (showPhoneVerify) {
      return (
        <div className='page-login-warp'>
          <div className="page-login">
            <div className='page-header'>
              <div className='page-title'>登录</div>
              <svg onClick={this.handleCancel} viewBox="64 64 896 896" class="" data-icon="close" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false"><path d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"></path></svg>
            </div>
            <Form className="login-form">
              <div className="verify-phone-hd">
                <div className="hd-tit">短信验证</div>
                <div className="hd-desc">
                  {sendingCodeStatus === 'doing' && `正在发送验证码至 ${verifyMobileNo}`}
                  {sendingCodeStatus === 'done' && `验证码已发送至 ${verifyMobileNo}`}
                  {sendingCodeStatus === 'fail' && <span>验证码发送至 {verifyMobileNo} <span style={{ color: 'red' }}>操作频繁，请1分钟后再试</span></span>}
                </div>
              </div>
              <FormItem>
                {getFieldDecorator('phoneVerifyCode', {
                  rules: [{ required: true, message: '请输入验证码' }],
                })(
                  <Input size="large" placeholder="短信验证码" allowClear
                    addonAfter={(
                      <div className="link" style={{ minWidth: 80, textAlign: 'center' }}
                        disabled={verifyTime > 0}
                        onClick={verifyTime > 0 ? null : this.sendPhoneVerifyCode}
                      >{
                          sendingCodeStatus === 'doing' ? '发送中...' :
                            verifyTime > 0 ? verifyTime + 's' : '获取验证码'}</div>
                    )}
                  />
                )}
              </FormItem>
              <FormItem style={{ marginBottom: 0 }}>
                <Button block
                  size="large"
                  type="primary"
                  loading={verifyLogining}
                  onClick={this.startPhoneVerify}
                >确定</Button>
              </FormItem>
            </Form>
          </div>
        </div>
      );
    }
    // 正常登录
    return (
      <div className='page-login-warp'>
        <div className="page-login">
          <div className='page-header'>
            <div className='page-title'>登录</div>
            <svg onClick={this.handleCancel} viewBox="64 64 896 896" class="" data-icon="close" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false"><path d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"></path></svg>
          </div>
          <Form className="login-form">
            {
              loginWithPwd ?
                <FormItem>
                  {getFieldDecorator('userName', {
                    rules: [{ required: true, message: '请输入用户名' }],
                  })(<Input size="large" prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="用户名" />)}
                </FormItem>
                :
                <FormItem >
                  {getFieldDecorator('phoneNo', {
                    rules: [
                      { required: true, message: '请输入手机号' },
                      // { pattern: /^1[3456789]\d{9}$/, message: '手机号错误' },
                    ],
                  })(
                    <Input
                      size="large"
                      placeholder="请输入手机号"
                      addonBefore={(
                        <Select
                          style={{ width: 80 }}
                          dropdownMatchSelectWidth={false}
                          optionLabelProp="code"
                          value={this.state.countryCode}
                          onChange={v => this.setState({ countryCode: v })}
                        >
                          {this.state.countryCodeList.map((item, i) => <Option key={i} value={item.countryCode} code={'+' + item.countryCode}>{item.countryCodeName}</Option>)}
                        </Select>
                      )}
                    />
                  )}
                </FormItem>
            }

            {
              loginWithPwd ?
                <FormItem>
                  {getFieldDecorator('passWord', {
                    rules: [{ required: true, message: '请输入密码' }],
                  })(<Input size="large" prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="密码" />)}
                </FormItem>
                :
                <FormItem>
                  {getFieldDecorator('phoneVerifyCodeSms', {
                    rules: [{ required: true, message: '请输入验证码' }],
                  })(
                    <Input size="large" placeholder="短信验证码" allowClear
                      addonAfter={(
                        <div className="link" style={{ minWidth: 80, textAlign: 'center' }}
                          disabled={verifyTime > 0}
                          onClick={verifyTime > 0 ? null : this.sendPhoneVerifyCodeSms}
                        >{
                            sendingCodeStatus === 'doing' ? '发送中...' :
                              verifyTime > 0 ? verifyTime + 's' : '获取验证码'}</div>
                      )}
                    />
                  )}
                </FormItem>
            }

            <div style={{
              backgroundColor: '#fff',
              width: '340px',
              marginBottom,
            }} id="verifyCode" />
            <FormItem style={{ marginBottom: 0 }}>
              <Button block
                size="large"
                type="primary"
                htmlType="submit"
                loading={logining}
                id='captcha-trigger-btn'
                onClick={loginWithPwd ? this.handleSubmitPwd : this.handleSubmitSms}
              >登录</Button>
            </FormItem>
            {/* 临时需求：内审要求登录弹窗不能有短信验证码登录 */}
            {/* <div className="switch-type-btn"
              onClick={() => {
                this.setState({
                  loginWithPwd: !loginWithPwd
                })
              }}
            >
              {loginWithPwd ? '短信验证码登录' : '密码登录'}
            </div> */}
          </Form>
        </div>
        </div>
    );
  }
}

export default Form.create()(withContext('authority')(Login));
